module.exports = __webpack_public_path__ + "img/syfw.4b8ca66.png";